<template>
    <div></div>
</template>

<script>
export default {
    name: 'Pixel',
    data() {
        return {
            pixel: process.env.VUE_APP_MCLIC,
        };
    },
    mounted() {
        KWKUniJS.conversion({
            mclic: this.pixel,
            argann: this.$store.state.argann,
            altid: this.$store.state.altid,
        });
    },
};
</script>

<style>

</style>
